import { render, staticRenderFns } from "./Test10.vue?vue&type=template&id=207d1e6a&scoped=true&"
import script from "./Test10.vue?vue&type=script&lang=js&"
export * from "./Test10.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d1e6a",
  null
  
)

export default component.exports